import { render, staticRenderFns } from "./WhatsAppBalanceInsufficientDialog.vue?vue&type=template&id=51c3fdfe"
import script from "./WhatsAppBalanceInsufficientDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppBalanceInsufficientDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WhatsAppBalanceInsufficientDialog.vue?vue&type=style&index=0&id=51c3fdfe&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/compass-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c3fdfe')) {
      api.createRecord('51c3fdfe', component.options)
    } else {
      api.reload('51c3fdfe', component.options)
    }
    module.hot.accept("./WhatsAppBalanceInsufficientDialog.vue?vue&type=template&id=51c3fdfe", function () {
      api.rerender('51c3fdfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globalDialog/WhatsAppBalanceInsufficientDialog.vue"
export default component.exports